import NodeDetails from './NodeDetails';

export default NodeDetails;
